import { useABAC } from '../../../hooks';

export const useCanManageTemplates = () => {
  const [canPerform, permissions] = useABAC();
  return canPerform(permissions.manageTemplates);
};
